import { useMutation } from "react-query";
import axios from "axios";

/**
 * Hook to fetch preflight data from an external adapter
 *
 * Used for adapters that require a two-step flow:
 * 1. Fetch preflight data (e.g., list of channels) - THIS HOOK
 * 2. User selects from preflight data
 * 3. Fetch actual data with selection (useFetchFromExternalSource)
 *
 * @param {Object} options
 * @param {string} options.sourceId - The adapter id (e.g., "slack")
 * @param {string} options.apiKey - User's API key for the external service
 */
export const useFetchPreflightData = () => {
  return useMutation({
    mutationFn: async ({ sourceId, apiKey, options }) => {
      const response = await axios.post(
        "/api/externalImport/fetchPreflightData",
        {
          source: {
            id: sourceId,
            apiKey,
            ...(options && { options }),
          },
        }
      );

      if (!response.data.success) {
        throw new Error(response.data.error || "Failed to fetch preflight data");
      }

      return response.data; // Returns: { success, preflightData: { ... } }
    },
  });
};
